export default class News {
  constructor() {
    this.target = document.querySelector('.js-top_news');
    this.isHidden = false;
    this.isTicking = false;
    this.currentAnimation = null;

    if(!this.target) {
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    this.checkAndAnimate();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
  }

  onScroll() {
    if(this.isTicking) {
      return;
    }

    this.isTicking = true;
    window.requestAnimationFrame(() => {
      this.checkAndAnimate();
      this.isTicking = false;
    });
  }

  checkAndAnimate() {
    const triggerPoint = window.innerHeight * 0.25;
    const currentScroll = window.scrollY || window.pageYOffset;

    if(currentScroll > triggerPoint && !this.isHidden) {
      this.hideAnimation();
      return;
    }

    if(currentScroll <= triggerPoint && this.isHidden) {
      this.showAnimation();
    }
  }

  hideAnimation() {
    const distanceLeft = this.target.offsetWidth * 1.2;
    this.isHidden = true;
    this.stopCurrentAnimation();

    if(this.target.animate) {
      this.currentAnimation = this.target.animate(
        [
          { transform: 'translateX(0)', offset: 0 },
          { transform: `translateX(-${distanceLeft}px)`, offset: 1 }
        ],
        {
          duration: 400,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards'
        }
      );
      return;
    }

    this.target.style.transform = `translateX(-${distanceLeft}px)`;
  }

  showAnimation() {
    const distanceLeft = this.target.offsetWidth * 1.2;
    this.isHidden = false;
    this.stopCurrentAnimation();

    if(this.target.animate) {
      this.currentAnimation = this.target.animate(
        [
          { transform: `translateX(-${distanceLeft}px)`, offset: 0 },
          { transform: 'translateX(0)', offset: 1 }
        ],
        {
          duration: 400,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards'
        }
      );
      return;
    }

    this.target.style.transform = 'translateX(0)';
  }

  stopCurrentAnimation() {
    if(this.currentAnimation) {
      this.currentAnimation.cancel();
      this.currentAnimation = null;
    }
  }
}
